import { DatePicker, Form, Input, InputNumber, Select, Switch } from "antd";
import { useForm } from "antd/lib/form/Form";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { useNavigate, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import Authorization from "../../../../component/Authorization";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import MUploadImage from "../../../../component/UploadImage";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { productService } from "../../product/service/product.service";
import { entityService } from "../../shared/service/entity.service";
import { fileService } from "../../shared/service/file.service";
import { Entity, EntityOption } from "../../shared/shared.model";
import { RouteContext } from "../../user/screen/components/route.context";
import {
  BenefitType,
  ConditionType,
  ProductSpecificationType,
  PromotionBase,
  PromotionProductType,
  PromotionUI,
} from "../entity/promotion.model";
import { promotionService } from "../service/promotion.service";
import EditPromotionProducts from "./components/EditPromotionProducts";

function EditPromotion() {
  const navigate = useNavigate();
  const { dispatch } = useContext(SpinContext);
  const { Option } = Select;
  const [promotion, setPromotion] = useState<PromotionUI>();
  const [brands, setBrands] = useState<Entity[]>([]);
  const [channels, setChannels] = useState<EntityOption[]>([]);
  const [condition, setCondition] = useState<ConditionType>();
  const [productSpecification, setProductSpecification] =
    useState<ProductSpecificationType>();
  const [benefitType, setBenefitType] = useState<BenefitType>();
  const [isProductSpecified, setIsProductSpecified] = useState<boolean>(true);
  const { state } = useContext(RouteContext);

  let { promotionId } = useParams();
  const [form] = useForm();

  const getPromotion = async (_promotionId: string) => {
    dispatch({ type: spinActions.BLOCK });
    let _promotion;

    try {
      _promotion = await promotionService.getPromotion(_promotionId);

      if (_promotion.conditionProducts.length > 0) {
        let conditionProducts = _promotion.conditionProducts;

        for (const _conditionProduct of conditionProducts) {
          _conditionProduct.product = await productService.getProduct(
            _conditionProduct.productId
          );
        }
      }

      if (_promotion.benefitProducts.length > 0) {
        let benefitProducts = _promotion.benefitProducts;

        for (const _benefitProduct of benefitProducts) {
          _benefitProduct.product = await productService.getProduct(
            _benefitProduct.productId
          );
        }
      }

      let file = await helper.getImage(_promotion.imgPath);

      _promotion = {
        ..._promotion,
        imgPath: file,
      };

      setCondition(_promotion?.promotionCondition);
      setProductSpecification(_promotion?.productSpecification);
      setIsProductSpecified(_promotion?.isProductSpecified);
      setBenefitType(_promotion?.benefitType);

      setPromotion(_promotion);
    } catch {
      dispatch({ type: spinActions.UNBLOCK });
    }

    dispatch({ type: spinActions.UNBLOCK });
  };

  useEffect(() => {
    if (promotionId) {
      getPromotion(promotionId).then();
    } else {
      setPromotion({
        name: "",
        startDate: moment(),
        endDate: moment(),
        stock: "",
        channels: [],
        conditionProducts: [],
        benefitProducts: [],
        isExclusive: false,
        isProductSpecified: false,
        isRepetitive: false,
      });
    }

    entityService.getBrands().then((_brands) => {
      _brands.sort((a, b) => a.name.localeCompare(b.name));
      setBrands(_brands);
    });

    entityService.getChannels().then((_channels) => {
      setChannels(_channels);
    });

    return () => {
      setBrands([]);

      setPromotion({
        name: "",
        startDate: moment(),
        endDate: moment(),
        stock: "",
        channels: [],
        conditionProducts: [],
        benefitProducts: [],
        isExclusive: false,
        isProductSpecified: false,
        isRepetitive: false,
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promotionId]);

  useEffect(() => {
    form.setFieldsValue({ isProductSpecified: true });
    setIsProductSpecified(true);
  }, [condition]);

  const onFinish = async (_promotion: PromotionBase) => {
    let fileResponse;

    try {
      fileResponse = await fileService.uploadFile(_promotion.imgPath);
      _promotion.imgPath = fileResponse.fileName;
    } catch (e) {
      return;
    }

    _promotion.routeId = state.routeId;

    if (promotion?.uuid) {
      _promotion.uuid = promotion.uuid;
      await promotionService.editPromotion(_promotion);
    } else {
      await promotionService.addPromotion(_promotion);
      navigate("/promotions");
    }

    dialog.success(
      `Промошн амжилттай ${!promotion?.uuid ? "нэмэгдлээ" : "шинэчлэгдлээ"}.`
    );

    navigate("/promotions");
  };

  const getBenefit = () => {
    if (benefitType === BenefitType.PRODUCT) {
      return (
        <Form.Item name="benefitProducts">
          <EditPromotionProducts type={PromotionProductType.BENEFIT_PRODUCT} />
        </Form.Item>
      );
    } else if (benefitType === BenefitType.FIXED_AMOUNT) {
      return (
        <div className="form-group">
          <label>Мөнгөн дүн</label>

          <Form.Item
            name="fixedAmount"
            rules={[
              {
                required: true,
                message: "Мөнгөн дүнгийг оруулна уу.",
              },
            ]}
            trigger="onValueChange"
          >
            <CurrencyInput
              className="ant-input"
              placeholder="Мөнгөн дүнгээ оруулна уу"
              prefix="₮"
              decimalScale={2}
            />
          </Form.Item>
        </div>
      );
    } else {
      return (
        <div className="form-group">
          <label>Хямдралын хувь</label>

          <Form.Item
            name="percentage"
            rules={[
              {
                required: true,
                message: "Хямдралын хувийг оруулна уу.",
              },
            ]}
            trigger="onValueChange"
          >
            <CurrencyInput
              className="ant-input"
              placeholder="Хямдралын хувийг оруулна уу"
              prefix="%"
              max={100.0}
              decimalScale={2}
            />
          </Form.Item>
        </div>
      );
    }
  };

  return (
    <>
      <MPageHeader crumbs={["Промошн"]} />
      <div className="content">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">Промошн мэдээлэл</h6>
          </div>
          <div className="card-body">
            {promotion && (
              <fieldset disabled={!helper.hasRoles(["promotion-full"])}>
                <Form initialValues={promotion} onFinish={onFinish} form={form}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>UUID</label>
                        <Form.Item name="uuid">
                          <Input readOnly={true} className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Нэр</label>
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "Нэрийг оруулна уу.",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Нэр оруулна уу"
                            className="form-control"
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Эхлэх огноо</label>
                        <Form.Item
                          name="startDate"
                          rules={[
                            {
                              required: true,
                              message: "Эхлэх огноог оруулна уу.",
                            },
                          ]}
                        >
                          <DatePicker
                            disabledDate={(d) =>
                              d.isBefore(moment().add(-1, "d"))
                            }
                            format={"YYYY-MM-DD"}
                            className="w-100"
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Дуусах огноо</label>
                        <Form.Item
                          name="endDate"
                          rules={[
                            {
                              required: true,
                              message: "Дуусах огноог оруулна уу.",
                            },
                          ]}
                        >
                          <DatePicker
                            disabledDate={(d) =>
                              d.isBefore(moment().add(-1, "d"))
                            }
                            format={"YYYY-MM-DD"}
                            className="w-100"
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Суваг сонгох</label>
                        <Form.Item
                          name="channels"
                          rules={[
                            {
                              required: true,
                              message: "Сувгуудыг сонгоно уу.",
                            },
                          ]}
                        >
                          <Select
                            mode="multiple"
                            allowClear
                            disabled={!helper.hasRoles(["promotion-full"])}
                            style={{ width: "100%" }}
                            placeholder="Суваг сонгох"
                          >
                            {channels.map((e) => (
                              <Option value={e.label}>{e.label}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Зураг сонгох</label>
                        <Form.Item
                          name="imgPath"
                          rules={[
                            {
                              required: true,
                              message: "Зураг оруулна уу.",
                            },
                          ]}
                        >
                          <MUploadImage
                            disabled={!helper.hasRoles(["promotion-full"])}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Давтамжид эсэх</label>
                        <Form.Item name="isRepetitive" valuePropName="checked">
                          <Switch
                            disabled={!helper.hasRoles(["promotion-full"])}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Урамшууллын нөхцлийн төрөл</label>
                        <Form.Item name="promotionCondition">
                          <Select
                            style={{ width: "100%" }}
                            placeholder="Нөхцөл сонгох"
                            onChange={setCondition}
                            disabled={!helper.hasRoles(["promotion-full"])}
                          >
                            <Option value="AMOUNT">Мөнгөн дүн</Option>
                            <Option value="NUMBER">Тоо ширхэг</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>{`${
                          condition === "AMOUNT"
                            ? "Мөнгөн дүнгийн доод хэмжээ"
                            : "Тоо ширхэгийн доод хэмжээ"
                        }`}</label>
                        <Form.Item name="minUnit">
                          <InputNumber />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Бүтээгдэхүүн заасан</label>
                    <Form.Item
                      name="isProductSpecified"
                      valuePropName="checked"
                    >
                      <Switch
                        onChange={setIsProductSpecified}
                        // disabled={
                        //   condition === "NUMBER" ||
                        //   !helper.hasRoles(["promotion-full"])
                        // }
                        disabled
                      />
                    </Form.Item>
                  </div>
                  {isProductSpecified && (
                    <div>
                      <div className="form-group">
                        <label>Бүтээгдэхүүний нөхцөл</label>
                        <Form.Item name="productSpecification">
                          <Select
                            style={{ width: "100%" }}
                            disabled={!helper.hasRoles(["promotion-full"])}
                            placeholder="Бүтээгдэхүүний нөхцөл сонгох"
                            onChange={setProductSpecification}
                          >
                            {!(
                              condition === "AMOUNT" && isProductSpecified
                            ) && <Option value="ONE">Нэг</Option>}
                            <Option value="MULTIPLE">Олон</Option>
                            {!(
                              condition === "NUMBER" && isProductSpecified
                            ) && <Option value="BRAND">Брэнд</Option>}
                          </Select>
                        </Form.Item>
                      </div>
                      {productSpecification ===
                        ProductSpecificationType.MULTIPLE && (
                        <div className="form-group">
                          <label>
                            Худалдан авах бүтээгдэхүүний төрлийн тоо
                          </label>
                          <Form.Item name="minDiverseCount">
                            <InputNumber />
                          </Form.Item>
                        </div>
                      )}
                      {productSpecification ===
                        ProductSpecificationType.BRAND && (
                        <div className="form-group">
                          <label>Брэнд</label>
                          <Form.Item
                            name="brandId"
                            rules={[
                              {
                                required: true,
                                message: "Брэндийг сонгоно уу.",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Брэнд сонгох"
                              disabled={!helper.hasRoles(["promotion-full"])}
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option!.children as unknown as string)
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                            >
                              {brands.map((brand) => (
                                <Option value={brand.uuid}>{brand.name}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      )}
                      {productSpecification !==
                        ProductSpecificationType.BRAND && (
                        <Form.Item name="conditionProducts">
                          <EditPromotionProducts
                            type={PromotionProductType.CONDITION_PRODUCT}
                          />
                        </Form.Item>
                      )}
                    </div>
                  )}

                  <div className="form-group">
                    <label>Урамшууллын төрөл</label>
                    <Form.Item name="benefitType">
                      <Select
                        disabled={!helper.hasRoles(["promotion-full"])}
                        style={{ width: "100%" }}
                        placeholder="Урамшууллын төрлийг сонгоно уу"
                        onChange={setBenefitType}
                      >
                        <Option value="PRODUCT">Бүтээгдэхүүн</Option>
                        <Option value="FIXED_AMOUNT">Мөнгөн дүн</Option>
                        <Option value="PERCENTAGE">Хувиар</Option>
                      </Select>
                    </Form.Item>
                  </div>

                  {getBenefit()}

                  <Authorization roles={["promotion-full"]}>
                    <div className="text-right">
                      <button type="submit" className="btn btn-primary">
                        Хадгалах <i className="icon-floppy-disk ml-2" />
                      </button>
                    </div>
                  </Authorization>
                </Form>
              </fieldset>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default EditPromotion;
